import {yupResolver} from '@hookform/resolvers/yup'
import {Dispatch, FC, SetStateAction, useCallback, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {FormProvider, useForm, useFormContext} from 'react-hook-form'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {SelectAsyncWrapper2} from '../../../../../../components/UI/Form/Input'
import {ShowSnackBar} from '../../../../../../util/functions'
import {formatDate} from '../../../../../../util/dates'
import {ScanModelDto, ServicePendingDto} from '../../../../model/multiUserCrew.model'
import {manualScanCensusSchema} from '../../../../schema/multiUserCrew'
import {MULTI_USER_CREW_SERVICES} from '../../../../services/multi-user-crew.service'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  onScanSuccess?: () => void
}

type Option = {
  value: string
  label: string
}

export const ModalAddCleaningActivity: FC<Props> = ({show, setShow, onScanSuccess}) => {
  const methods = useForm<any>({
    resolver: yupResolver(manualScanCensusSchema),
  })

  const {handleSubmit, reset, setValue} = methods
  const formContext = useFormContext()
  const [selectedActividad, setSelectedActividad] = useState<Option | null>(null)

  const loadOptionsActividad = useCallback(
    async (inputValue: string): Promise<Option[]> => {
      try {
        const term = inputValue.trim()
        const fechaInicio = formatDate(new Date())
        const fechaFin = formatDate(new Date())
        const campamentoId = formContext.watch('CampamentoId')
        const programacionServicioId = formContext.watch('ProgramacionServicioId')
        const isCampamentoTodos = !campamentoId || campamentoId === null || campamentoId === ''

        const filters: ServicePendingDto = {
          ...(isCampamentoTodos ? {} : {CampamentoId: campamentoId}),
          ...(isCampamentoTodos ? {} : {ServiceSchedulingId: programacionServicioId}),
          FechaIni: fechaInicio,
          FechaFin: fechaFin,
          Estados: ['1', '3'],
          pageNumber: 1,
          size: 10,
          isCombo: true,
          ...(term ? {Actividad: term} : {}),
        }

        const {data: response} = await MULTI_USER_CREW_SERVICES.getListPendingScan(filters)

        return (response.data || []).map((item: any) => ({
          value: item.ActividadConfiguracionId,
          label: item.Actividad,
        }))
      } catch (error) {
        console.error('Error al buscar actividades:', error)
        return []
      }
    },
    [formContext],
  )

  const handleActividadChange = (selected: Option | null) => {
    setSelectedActividad(selected)
    setValue('ActividadId', selected?.value || '')
  }

  const handleClose = () => {
    setShow(false)
    reset()
    setSelectedActividad(null)
  }

  const onSubmit = async (data: any) => {
    const dto: ScanModelDto = {
      ServiceSchedulingId: formContext.watch('ProgramacionServicioId'),
      ActividadConfiguracionId: data.ActividadId,
    }

    try {
      const {data: response} = await MULTI_USER_CREW_SERVICES.createScan(dto)

      if (!response.error) {
        ShowSnackBar('Actividad ingresada correctamente', 'success')
        setTimeout(() => {
          onScanSuccess?.()
        }, 300)
      } else {
        ShowSnackBar(response.message || 'Error al ingresar la actividad', 'error')
      }
    } catch (e: any) {
      ShowSnackBar(e.message || 'Error al ingresar la actividad', 'error')
    } finally {
      handleClose()
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-mobile-top'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Agregar Actividad de Limpieza</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='d-flex row'>
                <div className='mb-2 col-12'>
                  <SelectAsyncWrapper2
                    labelText='Actividad de Limpieza'
                    name='ActividadId'
                    loadOptions={loadOptionsActividad}
                    onChangeValue={handleActividadChange}
                    textPlaceholder='Escribe actividad...'
                    value={selectedActividad}
                    isClearable
                  />
                </div>
              </div>

              <div className='d-flex justify-content-center mb-3'>
                <button
                  type='button'
                  className='btn btn-sm btn-light-primary me-5'
                  onClick={handleClose}
                >
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-sm btn-primary'
                  onClick={handleSubmit(onSubmit)}
                >
                  Agregar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}
